<template>
  <vs-popup
    fullscreen
    :title="title_popup"
    :active.sync="config.isActive"
    id="add-appointment-popup"
    @close="closePopupFromIcon"
    :key="config.appointmentId"
  >
    <div class="flex add-popup-content">
      <div
        class="
          lg:w-2/3
          md:w-2/3
          w-1/2
          flex flex-col
          align-center
          position-relative
        "
        :class="{ 'overflow-hidden': isActiveSearch }"
      >
        <div class="w-full h-full overflow-auto">
          <div class="w-11/12">
            <div class="mb-6 pb-5">
              <vs-col
                class="flex justify-between align-center w-11/12 mb-4"
                vs-offset="1"
              >
                <div class="flex position-relative">
                  <!-- <datepicker
                    id="edit-popup-datepicker"
                    :format="customFormatter"
                    ref="datepicker"
                    class="font-bold"
                    style="padding: 2px; z-index: 90001"
                    v-model="datePicked"
                  ></datepicker> -->
                  <date-picker id="edit-popup-datepicker" format="dddd, DD MMM YYYY" v-model="datePicked" type="date" :editable="false" :clearable="false"></date-picker>
                  <div class="flex align-center date-content font-extrabold pointer-events-none">
                    <span>{{ customFormatter(datePicked) }}</span>
                    <feather-icon
                      icon="ChevronDownIcon"
                      svgClasses="w-5 stroke-current ml-2"
                    />
                  </div>
                </div>
                <div
                  class="
                    text-hover-underline text-primary
                    cursor-pointer
                    flex
                    align-center
                    user-select-none
                  "
                ></div>
              </vs-col>
              <transition-group name="list">
                <div
                  v-for="(line, index) in lines"
                  :key="line.index"
                  v-on:click="activeLine = line"
                >
                  <vs-row class="flex align-center mt-4">
                    <vs-col class="w-1/12 flex justify-center">
                      <div
                        class="
                          rounded-full
                          flex
                          align-center
                          justify-center
                          text-primary
                          index-icon
                        "
                      >
                        {{ index + 1 }}
                      </div>
                    </vs-col>
                    <vs-col class="w-11/12">
                      <vx-card class="appointment-card shadow-md">
                        <div>
                          <div
                            class="text-right cursor-pointer"
                            v-if="!blockRemoval"
                          >
                            <feather-icon
                              icon="XIcon"
                              svgClasses="w-6 h-6 stroke-current"
                              @click.stop="removeLine(index)"
                            />
                          </div>
                          <div class="lg:flex lg:mb-6">
                            <div class="form-control lg:w-2/5 w-full mr-4">
                              <label class="font-extrabold">Start time</label>
                              <!-- <v-select
                                label="text"
                                v-model="line.start_time"
                                :options="start_times"
                                :clearable="false"
                                :searchable="false"
                                class="w-100 start-time-select"
                                @input="selectStartTime(line)"
                              ></v-select> -->
                              <vs-dropdown vs-trigger-click>
                                <vs-input class="w-full p-0" :value="line.start_time ? line.start_time.text : ''" readonly></vs-input>
                                <transition name="dropdown-list">
                                  <vs-dropdown-menu class="w-full add-appointment__dropdown">
                                    <vs-dropdown-item v-for="(option, index) in start_times" :key="index" @click="line.start_time = option, selectStartTime(line)">
                                      {{ option.text }}
                                    </vs-dropdown-item>
                                  </vs-dropdown-menu>
                                </transition>
                              </vs-dropdown>
                            </div>
                            <div class="form-control lg:w-3/5 w-full">
                              <label class="font-extrabold">Service</label>
                              <!-- <v-select
                                label="name"
                                :options="services"
                                class="w-100"
                                v-model="line.service"
                                :clearable="false"
                                :searchable="true"
                                @input="selectService(line)"
                              ></v-select>-->
                              <vs-input
                                class="w-full"
                                :value="line.service ? line.service.name : ''"
                                readonly
                                @click="openPopupService"
                              ></vs-input>
                              <!-- <vs-popup-service
                                type="appointment"
                                :popupService="popupService"
                                :key="key_service"
                                @AddService="selectService"
                              ></vs-popup-service> -->
                            </div>
                          </div>
                          <div class="lg:flex">
                            <div class="form-control lg:w-2/5 w-full mr-4">
                              <label class="font-extrabold">Duration</label>
                              <!-- <v-select
                                label="text"
                                :options="durations"
                                v-model="line.duration"
                                :clearable="false"
                                :searchable="false"
                                class="w-100 duration-select"
                                @input="selectDuration(line)"
                              ></v-select> -->
                              <vs-dropdown vs-trigger-click>
                                <vs-input class="w-full p-0" :value="line.duration ? line.duration.text : ''" readonly></vs-input>
                                <transition name="dropdown-list">
                                  <vs-dropdown-menu class="w-full add-appointment__dropdown">
                                    <vs-dropdown-item v-for="(option, index) in durations" :key="index" @click="line.duration = option, selectDuration(line)">
                                      {{ option.text }}
                                    </vs-dropdown-item>
                                  </vs-dropdown-menu>
                                </transition>
                              </vs-dropdown>
                            </div>
                            <div class="form-control lg:w-3/5 w-full">
                              <label class="font-extrabold">Staff</label>
                              <!-- <v-select
                                label="name"
                                :options="staffs"
                                v-model="line.staff"
                                :clearable="false"
                                :searchable="false"
                                class="w-100"
                                @input="selectStaff(line)"
                              ></v-select>-->
                              <vs-input
                                class="w-full"
                                :value="line.staff ? line.staff.name : ''"
                                @click="openPopupStaff(line)"
                                readonly
                              ></vs-input>
                              <!-- <checkout-staff-popup
                                type="appointment"
                                :popupStaff="popupStaff"
                                @SelectStaff="selectStaff"
                              ></checkout-staff-popup> -->
                              <span
                                class="text-warning text-sm"
                                v-if="line.warning == 1"
                                >{{ "⚠ " + line.message }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </vx-card>
                    </vs-col>
                    <vs-col class="w-11/12 mt-5" vs-offset="1">
                      <a
                        class="text-hover-underline user-select-none"
                        href="#"
                        v-if="
                          index + 1 === lines.length &&
                          lines[0].service != null &&
                          lines[lines.length - 1].service != null
                        "
                        @click="addLine"
                        >Add more service</a
                      >
                    </vs-col>
                  </vs-row>
                </div>
              </transition-group>
              <vs-col class="w-11/12 mt-5" vs-offset="1">
                <ul class="centerx flex gap-x-8">
                  <li>
                    <vs-checkbox v-model="extra_data.request">Requested</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="extra_data.highlight">
                      <p class="flex items-center">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.0204 12.83L16.8004 11.61C16.5104 11.36 16.3404 10.99 16.3304 10.58C16.3104 10.13 16.4904 9.68 16.8204 9.35L18.0204 8.15C19.0604 7.11 19.4504 6.11 19.1204 5.32C18.8004 4.54 17.8104 4.11 16.3504 4.11H5.90039V3.25C5.90039 2.84 5.56039 2.5 5.15039 2.5C4.74039 2.5 4.40039 2.84 4.40039 3.25V21.75C4.40039 22.16 4.74039 22.5 5.15039 22.5C5.56039 22.5 5.90039 22.16 5.90039 21.75V16.87H16.3504C17.7904 16.87 18.7604 16.43 19.0904 15.64C19.4204 14.85 19.0404 13.86 18.0204 12.83Z"
                            fill="#FFD055"
                          />
                        </svg>
                        <span>Highlight</span>
                      </p>
                    </vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox
                      v-model="extra_data.no_show"
                      :disabled="isDisableNoShowCheckbox"
                    >No-show</vs-checkbox>
                  </li>
                </ul>
              </vs-col>
              <vs-col class="w-11/12 mt-5" vs-offset="1">
                <label class="font-extrabold">Appointment notes</label>
                <vs-textarea
                  class="mt-1"
                  height="110"
                  placeholder="Add an appointment note (visible to staff only)"
                  v-model="note"
                />
              </vs-col>
            </div>
          </div>
        </div>
        <div
          class="background-close cursor-pointer"
          :class="{ 'show-search': isActiveSearch }"
          @click="hideSearch"
        >
          <div class="w-full h-full position-relative">
            <div class="close-button translate-center">
              <div class="flex flex-col align-center">
                <div class="flex justify-center align-center close-icon">
                  <feather-icon icon="XIcon" svgClasses="w-7 stroke-current" />
                </div>
                <p class="py-6" style="color: #fff">CLICK TO CLOSE</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          lg:w-1/3
          md:1/3
          w-1/2
          h-full
          position-relative
          border-left-custom
          right-content
        "
      >
        <!-- <VuePerfectScrollbar :settings="psSettings"> -->
        <div class="ml-4 my-4 mb-2">
          <vs-input
            icon="search"
            icon-after="true"
            label-placeholder="Search for customer"
            class="mx-auto mt-0"
            style="width: 100%"
            @focus="showSearch"
            @keyup="searchCustomer"
            v-model.lazy="search"
          />
        </div>
        <div style="height: calc(100% - 150px) !important; overflow: auto">
          <div
            class="w-full h-full"
            :class="{ 'show-not-search': isActiveSearch }"
          >
            <div
              class="flex flex-col align-center h-full w-full overflow-hidden"
              v-if="!isSelected"
            >
              <img
                src="../../assets/images/appointment/searchList.svg"
                class="svg-icon"
              />
              <p class="px-5 text-center" style="margin-bottom: 60px">
                Use the search to add a customer
              </p>
            </div>

            <div
              class="
                flex flex-col
                align-center
                h-full
                w-full
                overflow-hidden
                position-relative
                mini-scroll
                pl-4
              "
              v-else
            >
              <div style="position: absolute; top: 5px; right: 5px">
                <feather-icon
                  icon="XIcon"
                  svgClasses="h-6 w-6 stroke-current cursor-pointer"
                  class="block"
                  @click.stop="removeCustomer"
                />
              </div>
              <div
                class="flex align-center w-full justify-center"
                style="border-bottom: 1px solid #e5e5e5"
              >
                <!-- <vs-avatar size="35px" class="m-5" />
                <div>
                  <p class="font-bold text-base">{{selectedCustomer.full_name}}</p>
                  <p class="text-sm">{{selectedCustomer.email}}</p>
                  <div class="flex text-sm">
                    <feather-icon icon="PhoneIcon" svgClasses="h-3 w-3 mr-1" />
                    <span>{{phoneNumberFormat(selectedCustomer.phone)}}</span>
                  </div>
                </div>-->
                <div
                  class="flex flex-col justify-center align-center mb-1"
                  style="height: 150px"
                  v-if="selectedCustomer"
                >
                  <vs-avatar size="35px" class="mx-5" />
                  <div class="flex flex-col align-center justify-center">
                    <p
                      class="font-bold text-lg font-extrabold p-0"
                      v-if="isInitial"
                    >
                      {{ appointmentDetail.booker_name }}
                    </p>
                    <p class="font-bold text-lg font-extrabold p-0" v-else>
                      {{ selectedCustomer.full_name }}
                    </p>
                    <p class="text-grey-custom text-sm p-0">
                      {{ selectedCustomer.email }}
                    </p>
                    <div class="flex text-grey-custom text-sm">
                      <feather-icon
                        icon="PhoneIcon"
                        svgClasses="h-4 w-4 mr-1"
                      />
                      <span>{{ StringHelper.phoneNumberFormat(selectedCustomer.phone, hide_phone) }}</span>
                    </div>
                    <p class="text-grey-custom text-sm p-0" v-if="selectedCustomer.note">
                      <feather-icon
                        icon="ClipboardIcon"
                        svgClasses="h-4 w-4 mr-1 mt-1"
                      />
                      <span>{{ selectedCustomer.note }}</span>
                    </p>
                  </div>
                </div>
                <div
                  class="flex flex-col align-center justify-center mb-1"
                  style="height: 110px"
                  v-else
                >
                  <vs-avatar size="35px" class="mx-5" />
                  <div class="flex flex-col align-center justify-center">
                    <p class="font-bold text-lg font-extrabold booker-name" v-if="!edit_name" @click="edit_name = !edit_name">
                      {{ booker_name_temp }}
                      <span class="pen-icon"></span>
                    </p>
                    <vs-input v-model="booker_name_temp" autofocus class="text-lg font-extrabold edit-booker-name-input" v-else></vs-input>
                    <p class="text-grey-custom text-sm p-0" v-if="config.customer && config.customer.email">
                      {{ config.customer.email }}
                    </p>
                    <div class="flex text-grey-custom text-sm">
                      <feather-icon
                        icon="PhoneIcon"
                        svgClasses="h-4 w-4 mr-1"
                      />
                      <span>{{ StringHelper.phoneNumberFormat(booker_phone_temp, hide_phone) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <vs-divider class="m-0"></vs-divider> -->

              <div
                class="flex justify-between py-2 mr-5 pb-5"
                v-if="customerHistory && (selectedCustomer || config.customer)"
              >
                <div class="text-center ml-5">
                  <div
                    class="text-lg font-extrabold"
                    v-if="customerHistory.total_appointment"
                  >
                    {{ customerHistory.total_appointment }}
                  </div>
                  <div class="text-lg font-extrabold" v-else>0</div>
                  <div class="text-grey-custom text-xs">Appointment</div>
                </div>
                <div class="text-center ml-5">
                  <div
                    class="text-lg font-extrabold"
                    v-if="customerHistory.total_money"
                  >
                    ${{
                      +(Math.round(customerHistory.total_money + "e+2") + "e-2")
                    }}
                  </div>
                  <!-- >${{customerHistory.total_money}}</div> -->
                  <div class="text-lg font-extrabold" v-else>$0</div>
                  <div class="text-grey-custom text-xs">Spent</div>
                </div>
                <div class="text-center ml-5">
                  <div
                    class="text-lg font-extrabold"
                    v-if="customerHistory.lifetime_point"
                  >
                    {{ customerHistory.lifetime_point }}
                  </div>
                  <div class="text-lg font-extrabold" v-else>0</div>
                  <div class="text-grey-custom text-xs">Point</div>
                </div>
                <div class="text-center ml-5">
                  <div
                    class="text-lg font-extrabold"
                    v-if="customerHistory.visit_count"
                  >
                    {{ customerHistory.visit_count }}
                  </div>
                  <div class="text-lg font-extrabold" v-else>0</div>
                  <div class="text-grey-custom text-xs">Visit</div>
                </div>
              </div>

              <!-- <vs-tabs
                :color="colorx"
                style="background: #fff"
                v-if="selectedCustomer && customerHistory"
              >
                <vs-tab class="border-bottom-custom" @click="colorx='primary'" label="Checkin">
                  <div v-if="customerHistory.checkin && customerHistory.checkin.length">
                    <div
                      class="con-tab-ejemplo py-3 pl-4 pr-2 border-bottom-custom leading-tight"
                      v-for="(item, index) in customerHistory.checkin"
                      :key="index"
                    >
                      <p
                        class="font-bold mb-6 text-primary"
                        v-if="showYear[index]"
                      >{{getYear(getYear(item.created_at))}}</p>
                      <div class="flex align-center pt-1">
                        <div class="pr-6">
                          <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.created_at)}}</p>
                          <p class="text-grey-custom pt-0">{{getMonth(item.created_at)}}</p>
                        </div>
                        <div>
                          <p class="pt-0">
                            <span class="text-grey-custom text-xs">{{getDayOfWeek(item.created_at)}}</span>
                            <span
                              class="text-xs ml-3 text-uppercase"
                              :class="[`text-${getStatusColor(item.status)}`]"
                            >{{item.status}}</span>
                          </p>
                          <div>
                            <p class="font-bold text-md pt-0">Check in</p>
                          </div>
                        </div>
                        <div
                          class="font-bold ml-auto text-lg"
                          v-if="item.total_price"
                        >${{item.total_price}}</div>
                        <div class="font-bold ml-auto text-lg" v-else>$0</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="con-tab-ejemplo p-6">No checkin history</div>
                </vs-tab>

                <vs-tab class="border-bottom-custom" @click="colorx='primary'" label="Invoice">
                  <div class="con-tab-ejemplo p-6">No invoice</div>
                </vs-tab>

                <vs-tab class="border-bottom-custom" @click="colorx='primary'" label="Appointment">
                  <div v-if="customerHistory.appointment && customerHistory.appointment.length">
                    <div
                      class="con-tab-ejemplo py-3 pl-4 pr-2 border-bottom-custom leading-tight"
                      v-for="(item, index) in customerHistory.appointment"
                      :key="index"
                    >
                      <p
                        class="font-bold mb-6 text-primary"
                        v-if="showYear[index]"
                      >{{getYear(getYear(item.start_time))}}</p>
                      <div class="flex align-center pt-1">
                        <div class="pr-6">
                          <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.start_time)}}</p>
                          <p class="text-grey-custom pt-0">{{getMonth(item.start_time)}}</p>
                        </div>
                        <div>
                          <p class="pt-0">
                            <span class="text-grey-custom text-xs">{{getDayOfWeek(item.start_time)}}</span>
                            <span
                              class="text-xs ml-3 text-uppercase"
                              :class="[`text-${getStatusColor(item.status)}`]"
                            >{{item.status}}</span>
                          </p>
                          <div>
                            <p class="font-bold text-md pt-0">{{item.service.name}}</p>
                            <p
                              class="text-grey-custom text-xs mt-1 pt-0"
                            >1h with {{getStaffName(item.employee_id)}}</p>
                          </div>
                        </div>
                        <div
                          class="font-bold ml-auto text-lg"
                          v-if="item.service.price"
                        >${{item.service.price}}</div>
                        <div class="font-bold ml-auto text-lg" v-else>$0</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="con-tab-ejemplo p-6">No appointment history</div>
                </vs-tab>
              </vs-tabs>-->

              <appointment-tabs
                class="customer-tabs"
                v-if="(selectedCustomer || config.customer) && customerHistory"
                :customerId="customerId"
                :key="customerId"
              ></appointment-tabs>

              <div v-else class="con-tab-ejemplo p-6">
                This is a new customer
              </div>
            </div>
          </div>

          <div
            class="h-full"
            style="display: none"
            :class="{ 'show-search': isActiveSearch }"
          >
            <div class="p-4 pt-0 border-bottom-custom pl-0 ml-4">
              <div
                class="
                  repeat
                  text-primary
                  cursor-pointer
                  flex
                  align-center
                  justify-center
                  text-hover-underline
                  user-select-none
                  mx-auto
                "
                @click="openPopupBooker"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="w-5 stroke-current mr-1"
                />Create new client
              </div>
            </div>
            <div
              class="
                w-full
                overflow-auto
                vs-con-loading__container
                pl-4
                customer-list-search-scroll
              "
              style="height: calc(100% - 90px)"
              id="customer-list-search"
            >
              <div
                :v-if="customerList"
                v-for="customer in customerList"
                :key="customer.id"
                class="flex align-center cursor-pointer customer-item"
                style="border-bottom: 1px solid #e5e5e5"
                @click="selectCustomer(customer)"
              >
                <vs-avatar size="35px" class="m-5" />
                <div>
                  <p class="font-bold text-base p-0">
                    {{ customer.full_name }}
                  </p>
                  <p class="text-sm p-0">{{ customer.email }}</p>
                  <!-- <p class="text-sm">{{customer.phone}}</p> -->
                  <div class="flex text-sm">
                    <feather-icon icon="PhoneIcon" svgClasses="h-3 w-3 mr-1" />
                    <span>{{
                      StringHelper.phoneNumberFormat(customer.phone)
                    }}</span>
                  </div>
                  <p class="text-sm p-0" v-if="customer.note">
                    Note: {{ customer.note }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col align-center pt-4 w-full"
          style="position: absolute; bottom: 0; left: 0"
        >
          <!-- <vs-button color="primary" type="border">Primary</vs-button> -->
          <p class="pb-4 font-bold">
            Total:
            <span class="ml-1">$</span>
            <span>{{ totalPrice }}</span>
            <span class="ml-1">({{ totalDuration }})</span>
          </p>
          <vs-row class="pl-4">
            <!-- <vs-button
              type="filled"
              class="font-bold sm:text-xs text-sm shadow-md vx-col w-custom ml-auto py-4 px-2"
              style="background: #fff !important; color: #000"
            >EXPRESS CHECKOUT</vs-button>-->
            <vs-button
              v-if="config.isEdit == false || config.isCopy"
              color="primary"
              type="filled"
              class="
                gradient gradient-primary
                font-bold
                text-sm
                shadow-md
                vx-col
                w-full
                mx-auto
                py-4
                px-2
              "
              @click="confirmSaveAppointment"
              >SAVE APPOINTMENT</vs-button
            >
            <vs-button
              v-else
              color="primary"
              type="filled"
              class="
                gradient gradient-primary
                font-bold
                text-sm
                shadow-md
                vx-col
                w-full
                mx-auto
                py-4
                px-2
              "
              @click="confirmSaveAppointment"
              >UPDATE APPOINTMENT</vs-button
            >
          </vs-row>
        </div>
      </div>
    </div>
    <vs-popup
      id="popup-booker"
      class="popup-booker"
      title="Create Customer"
      :active.sync="activePopupBooker"
    >
      <vs-input
        label="Customer Name"
        :maxlength="30"
        v-validate="{ required: true, regex: '^[a-zA-Z0-9 ]+$' }"
        name="booker_name"
        v-model="booker_name"
        placeholder="Input customer name"
        class="w-full"
        :danger="errors.has('booker_name')"
        :danger-text="
          StringHelper.getErrorName(errors.first('booker_name'), 'booker_name')
        "
      />
      <vs-input
        label="Customer Phone"
        :maxlength="14"
        v-mask="'(###) ###-####'"
        type="tel"
        v-validate="'required'"
        name="booker_phone"
        v-model="booker_phone"
        placeholder="Input customer phone"
        class="w-full mt-4"
        :danger="errors.has('booker_phone')"
        :danger-text="
          StringHelper.getErrorPhone(
            errors.first('booker_phone'),
            'booker_phone'
          )
        "
        :key="keyPopupBooker"
        v-on:keypress="isNumber($event)"
      />
      <div class="mt-6 flex justify-center">
        <vs-button
          type="border"
          color="danger"
          class="mr-4"
          @click="activePopupBooker = false"
          >Cancel</vs-button
        >
        <vs-button type="border" @click="createCustomer">Create</vs-button>
      </div>
    </vs-popup>
    <vs-popup-service
      type="appointment"
      :popupService="popupService"
      :key="key_service"
      @AddService="selectService"
    ></vs-popup-service>
    <checkout-staff-popup
      type="appointment"
      :popupStaff="popupStaff"
      @SelectStaff="selectStaff"
    ></checkout-staff-popup>
  </vs-popup>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import Datepicker from "vuejs-datepicker";
import moment from "moment";
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { StringHelper } from "../../models/string_helper";

export default {
  name: "appointment-edit-popup",
  components: {
    // Datepicker,
    DatePicker,
    "v-select": vSelect,
    VuePerfectScrollbar,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },

    // datePickedData: {
    //   type: Date
    // }
  },
  watch: {
    lines() {
      this.blockRemoval = this.lines.length <= 1;
    },
    config: {
      immediate: true,
      deep: true,
      handler() {
        // if (this.config.isActive) {
        //   document.body.classList.add("overflow-hidden");
        // } else {
        //   document.body.classList.remove("overflow-hidden");
        // }
        if (
          typeof this.config.customer !== "undefined" &&
          this.config.customer
        ) {
          this.booker_name = this.config.customer.name;
          this.booker_phone = this.config.customer.phone;
          this.isSelected = true;
          this.selectedCustomer = null;
          this.booker_name_temp = this.booker_name;
          this.booker_phone_temp = this.booker_phone;
          this.hideSearch();

          this.$store.dispatch("customer/GET_CUSTOMER_HISTORY", this.config.customer.id);
        }
      },
    },
    activePopupBooker: {
      immediate: true,
      deep: true,
      handler() {
        if (this.activePopupBooker) {
          this.booker_name = "";
          this.booker_phone = "";
          this.errors.clear();
          if (this.search != "") {
            if (isNaN(this.search)) {
              this.booker_name = this.search;
            } else {
              this.booker_phone = this.search;
            }
          }

          this.$nextTick(() => {
            this.$validator.resume();
          });
        } else {
          this.$validator.pause();
        }
      },
    },
    appointmentDetail: {
      immediate: true,
      deep: true,
      handler() {
        if(this.appointmentDetail && this.config.isEdit) {
          this.note = this.appointmentDetail.note;
          if (this.appointmentDetail.extra_data) {
            const extra_data = JSON.parse(this.appointmentDetail.extra_data)
            this.extra_data = {
              request: extra_data.request === 1,
              highlight: extra_data.highlight === 1,
              no_show: extra_data.no_show === 1,
            }
            this.isDisableNoShowCheckbox =
              this.appointmentDetail &&
              this.appointmentDetail.deposit &&
              this.appointmentDetail.deposit.amount &&
              extra_data.no_show === 1
          }
        }
      }
    },
  },
  computed: {
    hide_phone() {
      let data = this.$store.getters["auth/config"];
      if(data && data.hide_customer_number_on_calendar == 1) {
        return true;
      }
      return false;
    },
    title_popup() {
      if (this.config.isEdit == false || this.config.isCopy == true) {
        return "Add New Appointment";
      } else {
        return "Edit Appointment";
      }
    },
    start_times() {
      let dow = (new Date(this.datePicked_temp)).getDay();
      return this.$store.getters["appointment/arrayTime"](dow);
    },
    services() {
      return this.$store.getters["service/list"];
    },
    staffs() {
      return this.$store.getters["staff/list"];
    },
    durations() {
      let result = [];
      for (let i = 0; i < 255; i = i + 15) {
        let hours = Math.floor(i / 60);
        let minutes = i - hours * 60;
        if (!isNaN(parseInt(hours)) && !isNaN(parseInt(minutes))) {
          result.push({ value: i, text: hours + "h" + minutes + "m" });
        }
      }
      return result;
    },
    customerList() {
      return this.$store.getters["customer/list"].items;
    },
    datePicked: {
      get() {
        let date = (new Date(this.datePicked_temp)).getDate();
        let month = (new Date(this.datePicked_temp)).getMonth();
        let year = (new Date(this.datePicked_temp)).getFullYear();

        return new Date(year, month, date);
        // return this.datePicked_temp;
      },
      set(value) {
        this.$store
          .dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", {
            date: moment(value).format("YYYY-MM-DD"),
            appointment_id: this.config.appointmentId,
          })
          .then(() => {
            this.datePicked_temp = value;
            this.checkWarning();
          });
      },
    },
    appointmentDetail() {
      return this.$store.getters["appointment/appointmentDetail"];
    },
    note: {
      get() {
        // if (this.appointmentDetail && this.config.isEdit) {
        //   this.note_temp = this.appointmentDetail.note;
        //   return this.appointmentDetail.note;
        // }
        // return "";
        return this.note_temp;
      },
      set(value) {
        this.note_temp = value;
      },
    },
    totalPrice() {
      let total = 0;
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].service) {
          if (this.lines[i].service.price != null) {
            total += parseInt(this.lines[i].service.price);
          }
        }
      }
      return total;
    },
    totalDuration() {
      let total = 0;
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].duration) {
          if (this.lines[i].duration.value != null) {
            total += parseInt(this.lines[i].duration.value);
          }
        }
      }
      let hours = Math.floor(total / 60);
      let minutes = total % 60;
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    },
    customerHistory() {
      return this.$store.getters["customer/history"];
    },
    currentDateEvent() {
      return this.$store.getters["appointment/specificDate"];
    },
  },
  methods: {
    myMaskedNumber(str) {
      let result = "(";
      let number = ('' + str).replace(/[^\d]/g, '');
      // if (number.length > 10) {
      //   number = number.substr(number.length - 10);
      // }
      // let num_arr = number.split("");
      // for(let i = 0; i < num_arr.length; i++) {
      //   result += num_arr[i];
      //   if(result.length == 4) {
      //     result += ") ";
      //   } else if(result.length == 9) {
      //     result += "-";
      //   }
      // }
      result += number.substr(0, 3);
      if(result.length == 4) {
        result += ") ";
      }
      result += number.substr(3, 3);
      if(result.length == 9) {
        result += "-";
      }
      result += number.substr(6);
      this.booker_phone = result;
      return result;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        if(charCode >= 48 && charCode <= 57 && this.booker_phone.length < 14) {
          // let data = this.booker_phone + String.fromCharCode(charCode);
          // this.booker_phone = this.myMaskedNumber(data);
          // evt.preventDefault();
          this.myMaskedNumber(this.booker_phone);
        }
        return true;
      }
    },
    openPopupService() {
      this.popupService.isOpen = true;
      if (this.services) {
        this.popupService.item_info = this.services;
      }
      this.key_service++;
    },
    openPopupStaff(line) {
      this.popupStaff.isOpen = true;
      this.popupStaff.item_info = {
        service: line.service,
        staff: line.staff,
      };
    },
    getStatusColor(status) {
      if (status == null) {
        return "primary";
      }
      status = status.toLowerCase();
      if (status == "scheduled" || status == "completed") {
        return "success";
      } else if (status == "cancel" || status == "pending") {
        return "danger";
      } else {
        return "primary";
      }
    },
    removeCustomer() {
      this.selectedCustomer = null;
      this.isSelected = false;
    },
    getStaffName(staff_id) {
      if (staff_id) {
        if (this.$store.getters["staff/detail"](staff_id)[0] !== undefined)
          return this.$store.getters["staff/detail"](staff_id)[0].name;
      }
      return "no staff";
    },
    // getShowYear() {
    //   this.showYear = [];
    //   // let curYear = moment(new Date()).format('YYYY');
    //   let curYear = moment().format("YYYY");
    //   let prev_year = curYear;
    //   let arr_appointment = this.$store.getters["customer/history"].appointment;
    //   for (let i = 0; i < arr_appointment.length; i++) {
    //     let year = this.getYear(arr_appointment[i].start_time);
    //     if (year == curYear) {
    //       this.showYear.push(false);
    //     } else if (year != prev_year) {
    //       prev_year = year;
    //       this.showYear.push(true);
    //     } else {
    //       this.showYear.push(false);
    //     }
    //   }
    // },
    getDayOfWeek(date) {
      return moment(date).format("ddd HH:mm");
    },
    getDayOfMonth(date) {
      return moment(date).format("DD");
    },
    getYear(date) {
      return moment(date).format("YYYY");
    },
    getMonth(date) {
      return moment(date).format("MMM");
    },
    createCustomer() {
      if (
        this.booker_name !== "" &&
        this.booker_phone !== "" &&
        this.booker_phone.length == 14 &&
        this.errors.first("booker_name") == undefined
      ) {
        this.activePopupBooker = false;
        this.isSelected = true;
        this.selectedCustomer = null;
        this.hideSearch();
        this.booker_name_temp = this.booker_name;
        this.booker_phone_temp = this.booker_phone;
      } else {
        if (this.booker_phone.length != 14) {
            this.$vs.notify({
              title: "Error",
              text: "Phone is not valid!",
              color: "danger",
              position: "top-right",
            });
        }
        else if (this.booker_name == "" || this.booker_phone == "") {
          this.$vs.notify({
            title: "Error",
            text: "Name or phone cannot be blank!",
            color: "danger",
            position: "top-right",
          });
        }
        // } else if(this.booker_phone.length < 10) {
        //   this.$vs.notify({
        //     title: "Error",
        //     text: "Phone must have 10 digits!",
        //     color: "danger",
        //     position: "top-right"
        //   });
        // }
      }
      this.$validator.validateAll();
    },
    closePopup(id = null) {
      if (this.config.isEdit) {
        if (id != null || id != false) {
          this.$emit("closePopup", { appointment_id: id, reopen: true });
        }
      } else {
        this.$emit("closePopup", { appointment_id: id, reopen: false });
      }
    },
    closePopupFromIcon(id = null) {
      if (this.config.isEdit) {
        if (id != null || id != false) {
          this.$emit("closePopupFromIcon", { appointment_id: id, reopen: true });
        }
      } else {
        this.$emit("closePopupFromIcon", { appointment_id: id, reopen: false });
      }
    },
    showSearch() {
      this.isActiveSearch = true;
    },
    hideSearch() {
      this.isActiveSearch = false;
    },
    customFormatter(date) {
      return moment(date, "dddd, DD MMM YYYY").format("dddd, DD MMM YYYY");
    },
    readableDuration(duration) {
      //duration from minutes
      let hours = Math.floor(duration / 60);
      let minutes = duration - hours * 60;
      if (!isNaN(parseInt(hours)) && !isNaN(parseInt(minutes))) {
        return hours + "h" + minutes + "m";
      }
      return duration;
    },
    addLine() {
      let init_start_time = this.lines[0].start_time.value;
      for (let i = 0; i < this.lines.length; i++) {
        init_start_time += this.lines[i].service.duration * 60;
      }
      let hours = Math.floor(init_start_time / 3600);
      let minutes = Math.floor((init_start_time - hours * 3600) / 60);
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let init_start_text = hours + ":" + minutes + " " + ampm;

      let checkEmptyLines = this.lines.filter((line) => line.service === null);
      if (checkEmptyLines.length >= 1 && this.lines.length > 0) return;
      this.lines.push({
        index: this.index++,
        start_time: { value: init_start_time, text: init_start_text },
        service: null,
        duration: null,
        warning: null,
        warning_service: null,
        message_service: null,
        warning_working_hours: null,
        message_working_hours: null,
        warning_blocked_time: null,
        message_blocked_time: null,
        warning_staff_busy: null,
        message_staff_busy: null,
        staff:
          this.config.staff_id &&
          this.$store.getters["staff/detail"](this.config.staff_id)
            ? this.$store.getters["staff/detail"](this.config.staff_id)[0]
            : null,
      });
    },
    removeLine(lineId) {
      if (!this.blockRemoval) this.lines.splice(lineId, 1);
    },
    // selectService(line) {
    //   for (let i = 0; i < this.lines.length; i++) {
    //     if (this.lines[i].index == line.index) {
    //       this.lines[i].staffs = line.service.employee_list;
    //       this.lines[i].duration = {
    //         value: line.service.duration,
    //         text: this.readableDuration(line.service.duration)
    //       };
    //     }
    //   }
    //   this.checkWarning();
    // },
    selectService(service) {
      if (this.activeLine) {
        for (let i = 0; i < this.lines.length; i++) {
          if (this.activeLine.index == this.lines[i].index) {
            this.lines[i].service = service;
            this.lines[i].staffs = service.employee_list;
            this.lines[i].duration = {
              value: service.duration,
              text: this.readableDuration(service.duration),
            };
          }
        }
      }
      this.popupService.isOpen = false;
      this.checkWarning();
    },
    selectStaff(staff) {
      if (this.activeLine) {
        for (let i = 0; i < this.lines.length; i++) {
          if (this.activeLine.index == this.lines[i].index) {
            this.lines[i].staff = staff;
          }
        }
        this.popupStaff.isOpen = false;
        this.checkWarning();
      }
    },
    selectStartTime(line) {
      if (line.start_time.value == 0) {
        if (this.lines[0].index == line.index) {
          let init_start_time =
            moment().get("hour") * 3600 +
            moment().get("minute") * 60 -
            ((moment().get("minute") * 60) % 900) +
            900;

          if (this.config.initDate) {
            init_start_time =
              moment(this.config.initDate).get("hour") * 3600 +
              moment(this.config.initDate).get("minute") * 60;
          }
          let hours = Math.floor(init_start_time / 3600);
          let minutes = Math.floor((init_start_time - hours * 3600) / 60);
          let ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? "0" + minutes : minutes;
          let init_start_text = hours + ":" + minutes + " " + ampm;
          this.lines[0].start_time = {
            text: init_start_text,
            value: init_start_time,
          };
        } else {
          for (let i = 0; i < this.lines.length; i++) {
            if (this.lines[i].index == line.index) {
              this.lines[i].start_time = this.lines[i - 1].start_time;
            }
          }
        }
      }
      this.checkWarning();
    },
    selectDuration(line) {
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].index == line.index) {
          this.lines[i].duration = line.duration;
        }
      }
    },
    checkTimeChanged() {
      if(!moment(this.datePicked_temp).isSame(moment(this.initial_datePicked))) {
        return true;
      }
      for(let i = 0; i < this.lines.length; i++) {
        if(this.lines[i].initial_start_time && this.lines[i].start_time.value != this.lines[i].initial_start_time.value) {
          return true;
        }
      }
      return false;
    },
    confirmTimeChangedMessage() {
      if(this.appointment_status == "confirmed" && this.checkTimeChanged()) {
        this.$vs.dialog({
          type: "confirm",
          title: "Confirmation",
          text: `Do you want to send a message to ${this.selectedCustomer ? this.selectedCustomer.full_name : 'this customer'} notifying about this change?`,
          accept: async () => {this.saveAppointment(true)},
          cancel: async () => {this.saveAppointment(false)},
          acceptText: 'Send',
          cancelText: `Don't Send`
        });
      } else if(this.appointment_status == "scheduled" && this.checkTimeChanged()) {
        this.saveAppointment(true);
      } else {
        this.saveAppointment();
      }
    },
    confirmSaveAppointment() {
      let isError = 0;
      for (let i = 0; i < this.lines.length; i++) {
        if (this.lines[i].warning == 1) {
          isError = 1;
          break;
        }
      }
      if (isError == 1) {
        this.$vs.dialog({
          type: "confirm",
          title: "Confirmation",
          text: "There are warnings on these appointments, are you still want to save?",
          // accept: this.saveAppointment,
          accept: this.confirmTimeChangedMessage,
        });
      } else {
        // this.saveAppointment();
        this.confirmTimeChangedMessage();
      }
    },
    saveAppointment(send_sms = null) {
      if (this.isSelected) {
        let form = {};
        if(send_sms != null) {
          form.send_sms = send_sms == true ? 1 : 0;
        }
        form.date = moment(this.datePicked).format("YYYY-MM-DD");
        let items = [];
        for (let i = 0; i < this.lines.length; i++) {
          // if (this.lines[i].service != null) {
          this.lines[i].staffs = null;
          items.push(this.lines[i]);
          // }
          if (this.lines[i].staff) {
            if (this.lines[i].staff.user_id == -1) {
              this.lines[i].staff = null;
            }
          }
        }
        form.items = items;
        form.customer = this.selectedCustomer;
        form.status = this.appointmentDetail;
        if (this.booker_name_temp !== "" && this.booker_phone_temp !== "") {
          form.booker = {
            booker_name: this.booker_name_temp,
            booker_phone: this.booker_phone_temp,
          };
        }
        form.note = this.note_temp;
        form.extra_data = {
          request: this.extra_data.request ? 1 : 0,
          highlight: this.extra_data.highlight ? 1 : 0,
          no_show: this.extra_data.no_show ? 1 : 0,
        };
        if(this.booker_name_temp != "" || form.customer) {
          this.$vs.loading({
            container: "#app",
            scale: 0.8,
          });
          if (this.config.isEdit && !this.config.isCopy) {
            let appointmentDetail =
              this.$store.getters["appointment/appointmentDetail"];
            form.appointment_base_id = appointmentDetail.id;
            form.status = appointmentDetail.status;
            this.$store
              .dispatch("appointment/UPDATE_APPOINTMENT", form)
              .then(() => {
                this.$vs.loading.close("#app > .con-vs-loading");
                this.closePopup(appointmentDetail.id);
                this.$vs.notify({
                  title: "Success",
                  text: "Updated Appointment Successfully!",
                  color: "success",
                  position: "top-right",
                });
              })
              .catch((err) => {
                console.log("Error: ", err);
                this.$vs.loading.close("#app > .con-vs-loading");
              });
          } else {
            this.$store
              .dispatch("appointment/CREATE_APPOINTMENT", form)
              .then(() => {
                this.$vs.loading.close("#app > .con-vs-loading");
                this.closePopup();
                this.$vs.notify({
                  title: "Success",
                  text: "Created Appointment Successfully!",
                  color: "success",
                  position: "top-right",
                });
              })
              .catch((err) => {
                console.log("Error: ", err);
                this.$vs.loading.close("#app > .con-vs-loading");
              });
          }
        } else {
          this.$vs.notify({
            title: "Fail",
            text: "Customer name cannot be blank!",
            color: "danger",
            position: "top-right",
          });
        }
      } else {
        // alert('Choosing customer is required!!');
        this.$vs.notify({
          title: "Fail",
          text: "Choosing customer is required!",
          color: "danger",
          position: "top-right",
        });
      }
    },
    searchCustomer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.$vs.loading({
        container: "#customer-list-search",
        scale: 0.8,
      });
      this.timer = setTimeout(() => {
        const obj = {
          keywords: this.search,
        };
        this.$store.dispatch("customer/GET_CUSTOMER_LIST", obj).then(() => {
          this.$vs.loading.close("#customer-list-search > .con-vs-loading");
        });
      }, 500);
    },
    selectCustomer(customer) {
      this.isInitial = false;
      this.isActiveSearch = false;
      this.selectedCustomer = customer;
      // this.$store
      //   .dispatch("customer/GET_CUSTOMER_HISTORY", customer.id)
      //   .then(() => {
      //     this.getShowYear();
      //   });
      this.$store.dispatch("customer/GET_CUSTOMER_HISTORY", customer.id).then(() => {
        this.tab_key++;
      });
      this.customerId = customer.id;
      this.isSelected = true;
    },
    openPopupBooker() {
      this.isInitial = false;
      this.activePopupBooker = true;
      // this.booker_name = "";
      // this.booker_phone = "";
      // if (isNaN(this.search)) {
      //   this.booker_name = this.search;
      // } else {
      //   this.booker_phone = this.search;
      // }
      this.keyPopupBooker = this.keyPopupBooker + 1;
    },
    checkWarning() {
      for (let i = 0; i < this.lines.length; i++) {
        this.lines[i].warning = 0;
        this.lines[i].message = "";
        this.lines[i].warning_service = 0;
        this.lines[i].message_service =
          "This staff is not available for this service";
        this.lines[i].warning_working_hours = 0;
        this.lines[i].message_working_hours =
          "This staff is not available for this appointment time";
        this.lines[i].warning_blocked_time = 0;
        this.lines[i].message_blocked_time =
          "This staff is blocked to booking this appointment time";
        this.lines[i].warning_staff_busy = 0;
        this.lines[i].message_staff_busy =
          "This staff has been booked with other service at this time";
        if (this.lines[i].staff != null && this.lines[i].service != null) {
          // console.log(this.lines[i]);
          if (this.lines[i].staff.service_ids) {
            this.lines[i].warning_service = 1;
            for (let j = 0; j < this.lines[i].staff.service_ids.length; j++) {
              if (
                this.lines[i].service &&
                this.lines[i].service.id ==
                  this.lines[i].staff.service_ids[j].service_id
              ) {
                this.lines[i].warning_service = 0;
                break;
              }
            }
          }
          if (this.lines[i].staff.working_hours) {
            if (this.lines[i].staff.working_hours[0] !== undefined) {
              if (
                this.lines[i].staff.working_hours[0].working_day.includes(
                  moment(this.datePicked).format("d")
                )
              ) {
                let dayName = moment(this.datePicked).format("dd");
                let time =
                  this.lines[i].staff.working_hours[0][
                    dayName.toLowerCase()
                  ].split(",");
                if (
                  this.lines[i].start_time.value < time[0] * 60 ||
                  this.lines[i].start_time.value > time[1] * 60
                ) {
                  this.lines[i].warning_working_hours = 1;
                }
              }
            }
          }
          // console.log(this.lines[i].service);
          // console.log(this.currentDateEvent);
          if (this.currentDateEvent != null) {
            // console.log(this.currentDateEvent);
            for (let j = 0; j < this.currentDateEvent.length; j++) {
              if (
                this.lines[i].staff.user_id ==
                this.currentDateEvent[j].resourceId
              ) {
                let appointmentStartTime =
                  parseInt(
                    moment(
                      moment(this.currentDateEvent[j].start).format(
                        "YYYY-MM-DD"
                      )
                    ).format("X")
                  ) + this.lines[i].start_time.value;
                let appointmentEndTime =
                  appointmentStartTime + this.lines[i].duration.value;
                let currentStartTime = parseInt(
                  moment(this.currentDateEvent[j].start).format("X")
                );
                let currentEndTime = parseInt(
                  moment(this.currentDateEvent[j].end).format("X")
                );
                // console.log(appointmentStartTime);
                // console.log(currentStartTime);
                // console.log(currentEndTime);

                if (
                  appointmentStartTime >= currentStartTime &&
                  appointmentStartTime <= currentEndTime
                ) {
                  this.lines[i].warning_staff_busy = 1;
                } else if (
                  appointmentEndTime >= currentStartTime &&
                  appointmentEndTime <= currentEndTime
                ) {
                  this.lines[i].warning_staff_busy = 1;
                }
                // if (
                //   appointmentTime <= endTime &&
                //   appointmentTime >= startTime
                // ) {
                //   this.lines[i].warning_staff_busy = 1;
                // }
              }
            }
          }
        }
        if (this.lines[i].warning_blocked_time == 1) {
          this.lines[i].warning = 1;
          this.lines[i].message = this.lines[i].message_blocked_time;
        }
        if (this.lines[i].warning_working_hours == 1) {
          this.lines[i].warning = 1;
          this.lines[i].message = this.lines[i].message_working_hours;
        }
        if (this.lines[i].warning_service == 1) {
          this.lines[i].warning = 1;
          this.lines[i].message = this.lines[i].message_service;
        }
        if (this.lines[i].warning_staff_busy == 1) {
          this.lines[i].warning = 1;
          this.lines[i].message = this.lines[i].message_staff_busy;
        }
      }
    },
  },
  data() {
    let init_start_time =
      moment().get("hour") * 3600 +
      moment().get("minute") * 60 -
      ((moment().get("minute") * 60) % 900) +
      900;

    if (this.config.initDate) {
      init_start_time =
        moment(this.config.initDate).get("hour") * 3600 +
        moment(this.config.initDate).get("minute") * 60;
    }
    let hours = Math.floor(init_start_time / 3600);
    let minutes = Math.floor((init_start_time - hours * 3600) / 60);
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let init_start_text = hours + ":" + minutes + " " + ampm;
    let datePicked_temp = this.config.initDate;
    if (datePicked_temp == null || datePicked_temp == undefined || this.config.isCopy) {
      datePicked_temp = new Date();
    }
    let clickedStaff = null;
    if (this.config.staff_id) {
      clickedStaff = this.$store.getters["staff/detail"](this.config.staff_id);
    }

    let lines = [];
    let selectedCustomer = null;
    let isSelected = false;
    let blockRemoval = true;

    let customerId = null;
    let index = 0;
    let appointment_status = null;
    if (this.config.appointmentId != null) {
      let appointmentDetail =
        this.$store.getters["appointment/appointmentDetail"];
      if(!this.config.isCopy) {
        datePicked_temp = appointmentDetail.date;
      }
      appointment_status = appointmentDetail.status;
      let appointmentArr = [];
      appointmentArr.push(appointmentDetail);
      for (
        let i = 0;
        i < appointmentDetail.additional_appointments.length;
        i++
      ) {
        appointmentArr.push(appointmentDetail.additional_appointments[i]);
      }
      if (appointmentArr.length > 1) {
        blockRemoval = false;
      }
      let ids = [];
      for (let i = 0; i < appointmentArr.length; i++) {
        let start_time_value = appointmentArr[i].start_time.split(":");
        let appointment_start_time_value =
          parseInt(start_time_value[0]) * 60 * 60 +
          parseInt(start_time_value[1]) * 60;
        
        if(this.config.isCopy) {
          appointment_start_time_value = init_start_time;
          if(lines && lines.length) {
            appointment_start_time_value = lines[lines.length - 1].start_time.value + lines[lines.length - 1].duration.value * 60;
          }
        }
        
        let hours = Math.floor(appointment_start_time_value / 3600);
        let minutes = Math.floor(
          (appointment_start_time_value - hours * 3600) / 60
        );
        let ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let appontment_init_start_text = hours + ":" + minutes + " " + ampm;
        ids.push(appointmentArr[i].id);
        lines.push({
          id: appointmentArr[i].id,
          index: appointmentArr[i].id,
          start_time: {
            value: appointment_start_time_value,
            text: appontment_init_start_text,
          },
          initial_start_time: {
            value: appointment_start_time_value,
            text: appontment_init_start_text,
          },
          service: appointmentArr[i].service,
          duration: appointmentArr[i].duration,
          initial_duration: appointmentArr[i].duration,
          staff: appointmentArr[i].employee,
          staffs: null,
        });
        selectedCustomer = appointmentDetail.customer;
        // this.$store
        //   .dispatch("customer/GET_CUSTOMER_HISTORY", selectedCustomer.id)
        //   .then(() => {
        //     this.getShowYear();
        //   });
        if (selectedCustomer != null) {
          customerId = selectedCustomer.id;
          isSelected = true;
        }
      }
      // index = Math.max(ids);
      if (ids && ids.length > 0) {
        for (let i = 0; i < ids.length; i++) {
          if (index < parseInt(ids[i])) {
            index = parseInt(ids[i]);
          }
        }
      }
    } else {
      lines = [
        {
          index: 0,
          start_time: { value: init_start_time, text: init_start_text },
          initial_start_time: { value: init_start_time, text: init_start_text },
          service: null,
          duration: null,
          initial_duration: null,
          staff: clickedStaff ? clickedStaff[0] : null,
          staffs: null,
        },
      ];
    }
    let initial_datePicked = datePicked_temp;
    return {
      StringHelper,
      activePopupBooker: false,
      keyPopupBooker: 0,
      booker_name: "",
      booker_phone: "",
      booker_name_temp: "",
      booker_phone_temp: "",
      index: index + 1,
      search: "",
      lines,
      psSettings: {
        // perfectscrollbar settings
        wheelSpeed: 0.6,
      },
      datePicked_temp,
      initial_datePicked,
      appointment_status,
      isActiveSearch: false,
      blockRemoval,
      selectedCustomer,
      isSelected,
      note_temp: "",
      colorx: "primary",
      showYear: [],
      popupStaff: {
        isOpen: false,
        item_info: {},
      },
      popupService: {
        isOpen: false,
        item_info: {},
      },
      key_service: 0,
      activeLine: lines.length > 0 ? lines[0] : null,
      isInitial: true,
      customerId,
      dow: 0,
      edit_name: false,
      extra_data: {
        highlight: false,
        request: false,
        no_show: false
      },
      isDisableNoShowCheckbox: false,
    };
  },
  mounted() {
    this.checkWarning();
  },
};
</script>
